import { Group, Pill } from '@mantine/core'
import { TablePlaceFilterInput } from 'common/inputs/TablePlaceFilterInput'
import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Category, Place, PremadeVariant } from 'types/products'
import { useTableWithProduct, VariantWithProduct } from './useTableWithProduct'

export function PremadeTableWithProduct() {
  const columns = useMemo<Array<MRT_ColumnDef<VariantWithProduct<PremadeVariant>>>>(
    () => [
      {
        accessorKey: 'product.symbol',
        header: 'Produkt',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po symbolu',
        },
      },
      {
        accessorKey: 'size',
        header: 'Wymiar',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wymiarze',
        },
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'finish',
        header: 'Wykończenie',
        enableSorting: false,
        size: 150,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wykończeniu',
        },
        Cell: ({ cell }) => {
          const finishes = cell.getValue<Array<string>>()
          return (
            <Group gap="xs">
              {finishes.map((finish) => (
                <Pill key={finish}>{finish}</Pill>
              ))}
            </Group>
          )
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        Filter: TablePlaceFilterInput,
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )

  const table = useTableWithProduct({
    category: Category.PREMADE,
    columns,
  })

  return <MantineReactTable table={table} />
}
